import { Button, Flex, rem, Title, TextInput } from "@mantine/core";
import { DataTable } from "mantine-datatable";
import { useCallback, useContext, useEffect, useState } from "react";
import Api from "../api.ts";
import { Conversation } from "../interfaces.ts";
import { Link } from "react-router-dom";
import { formatDateTime } from "../utils.ts";
import { KeycloakContext } from "../components/KeycloakProvider.tsx";

function Conversations({ pageSize = 25 }: { pageSize?: number }) {
  const { keycloak } = useContext(KeycloakContext);
  const [loading, setLoading] = useState(false);
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [page, setPage] = useState(1);
  const [totalConversations, setTotalConversations] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchConversations = useCallback(async () => {
    if (!keycloak) return;
    setLoading(true);

    try {
      await keycloak.updateToken(30); // refresh si le queda menos de 30s al token
      const accessToken = keycloak.token;

      if (!accessToken) {
        throw new Error("Token no disponible");
      }
      const response = await Api.getConversations(accessToken, page, pageSize, searchTerm);
      setConversations(response["items"]);
      setTotalConversations(response["total"]);
      setPage(response["page"]);
    } catch (err) {
      console.error("Error cargando conversaciones:", err);
      keycloak.logout(); // o muestra un error al usuario
    } finally {
      setLoading(false);
    }
  }, [keycloak, page, pageSize, searchTerm]);

  useEffect(() => {
    fetchConversations().catch(console.error);
  }, [fetchConversations]);

  return (
    <>
      <Flex mt={rem(50)} mb={rem(30)} justify="space-between" align="center">
        <Title size="h1">Conversations</Title>
        <TextInput
          placeholder="Search by conversation_id or ticket_id or ani"
          value={searchTerm}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSearchTerm(event.currentTarget.value);
            setPage(1);
          }}
          w={300}
        />
      </Flex>

      <DataTable
        fetching={loading}
        minHeight={conversations.length > 0 ? undefined : 200}
        columns={[
          {
            accessor: "conversation_id",
            render: (record: any) => record.conversation_id,
          },
          {
            accessor: "ticket_id",
            render: (record: any) => record.ticket_id,
          },
          {
            accessor: "ani",
            render: (record: any) => record.ani,
          },
          {
            accessor: "created_at",
            render: (record: any) => {
              return formatDateTime(new Date(record["created_at"]));
            },
          },
          {
            accessor: "",
            render: (record: Conversation) => {
              return (
                <Button
                  component={Link}
                  to={`/conversations/${record.id}`}
                  variant="outline"
                  size="xs"
                >
                  View
                </Button>
              );
            },
          },
        ]}
        page={page}
        pinLastColumn={true}
        records={conversations}
        totalRecords={totalConversations}
        recordsPerPage={pageSize}
        onPageChange={(newPage) => setPage(newPage)}
      />
    </>
  );
}

export default Conversations;
